import { motion } from "framer-motion";
import { Mail } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { CONTACT_EMAIL } from "../config";
import { ContactForm } from "./ContactForm";

const EASE = [0.16, 1, 0.3, 1];

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer data-testid="footer-section" className="relative overflow-hidden bg-[#0D0D0D]">
      <div id="contatto" className="relative scroll-mt-20 px-6 py-28 md:py-40 lg:px-10">
        <div className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[720px] -translate-x-1/2 -translate-y-1/2 bg-[radial-gradient(ellipse_at_center,rgba(230,81,0,0.14),rgba(197,160,89,0.08)_45%,transparent_70%)] blur-2xl" />
        <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 lg:grid-cols-2">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1, ease: EASE }}
          >
            <div className="mb-6 flex items-center gap-4">
              <span className="h-px w-12 bg-[#C5A059]" />
              <span className="font-manrope text-xs font-semibold uppercase tracking-[0.22em] text-[#C5A059]">
                {t.contact.kicker}
              </span>
            </div>
            <h2 className="font-bebas text-5xl uppercase leading-[0.9] tracking-tight text-[#F5F5F5] sm:text-6xl lg:text-7xl">
              {t.contact.heading}
            </h2>
            <p className="mt-6 max-w-xl font-manrope text-sm leading-relaxed text-[#8A9199] md:text-base">
              {t.contact.sub}
            </p>
            <div className="mt-10 flex flex-wrap items-center gap-2 font-manrope text-sm text-[#8A9199]">
              <Mail className="h-4 w-4 text-[#C5A059]" />
              <span>{t.contact.direct}</span>
              <a
                data-testid="cta-contact-email"
                href={`mailto:${CONTACT_EMAIL}`}
                className="font-semibold text-[#C5A059] transition-colors duration-300 hover:text-[#F5F5F5]"
              >
                {CONTACT_EMAIL}
              </a>
            </div>
          </motion.div>

          <ContactForm />
        </div>
      </div>

      <div className="border-t border-[#2A2A2A] px-6 py-10 lg:px-10">
        <div className="mx-auto flex max-w-7xl flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="font-bebas text-2xl tracking-[0.18em] text-[#F5F5F5]">
              METAL<span className="text-[#C5A059]">-CLASS</span>
            </p>
            <a
              data-testid="footer-contact-email"
              href={`mailto:${CONTACT_EMAIL}`}
              className="mt-2 inline-block font-manrope text-sm text-[#8A9199] transition-colors duration-300 hover:text-[#C5A059]"
            >
              {t.footer.contact}: {CONTACT_EMAIL}
            </a>
          </div>
          <p className="font-manrope text-xs text-[#5C636A]">{t.footer.rights}</p>
        </div>
      </div>

      <div aria-hidden className="pointer-events-none select-none overflow-hidden">
        <p className="text-stroke-steel whitespace-nowrap text-center font-bebas text-[11vw] leading-[0.75] tracking-tight">
          METAL—CLASS
        </p>
      </div>
    </footer>
  );
};
